import { render, staticRenderFns } from "./MobileUILayout.vue?vue&type=template&id=34820434&scoped=true&"
import script from "./MobileUILayout.vue?vue&type=script&lang=js&"
export * from "./MobileUILayout.vue?vue&type=script&lang=js&"
import style0 from "./MobileUILayout.vue?vue&type=style&index=0&id=34820434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34820434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34820434')) {
      api.createRecord('34820434', component.options)
    } else {
      api.reload('34820434', component.options)
    }
    module.hot.accept("./MobileUILayout.vue?vue&type=template&id=34820434&scoped=true&", function () {
      api.rerender('34820434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/Layout/MobileUILayout.vue"
export default component.exports